function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LesothoFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#55BA07",
      d: "M0 15h24v6H0v-6Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      d: "M0 9h24v6H0V9Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#3D58DB",
      d: "M0 3h24v6H0V3Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#1D1D1D",
      d: "M11.438 9.18c-.393.105-.6.376-.6.856 0 .548.27 1.062.6 1.327V9.18Zm.937 2.168c.32-.269.579-.773.579-1.31 0-.466-.204-.736-.579-.848v2.158ZM12.343 8.8c.614.137 1.058.555 1.058 1.234 0 .494-.235 1.094-.599 1.506l1.825 1.79.45-.148.673 1.02s-1.7.799-3.8.799c-2.1 0-3.7-.799-3.7-.799l.572-.871.463.151 1.693-1.91c-.38-.413-.627-1.032-.627-1.538 0-.703.476-1.127 1.123-1.247a.469.469 0 0 1 .87.013Z"
    })]
  })]
}));
//# sourceMappingURL=Lesotho.js.map